/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable max-len */
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { useAuthenticationContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { isImpersonating } from '@aarhus-university/au-lib-react-components/src/lib/portals';
import { useTranslation } from '@aarhus-university/au-lib-react-components/src/lib/hooks';
import { defaultLabels, importJson, TranslationsContext } from '../../lib/translation';
import MenuComponent from './MenuComponent';
import UtilityComponent from './UtilityComponent';
import { useImpersonationContext } from '../../lib/context';

const MenuWrapperComponent: FC = () => {
  const lang = window.userContext.preferredLanguage || window.appLang;
  const authenticated = useAuthenticationContext();
  const {
    isStudent, isImpersonator, canViewedUserBeImpersonated, isApplicant,
  } = useImpersonationContext();
  const translations = useTranslation<IMitStudieTranslation>(defaultLabels, [importJson('signin-menu', lang), importJson('generics', lang)], lang);
  const canImpersonateButHaveNotActivatedItYet = isImpersonator && !isStudent && !isImpersonating();
  const noAccess = !isStudent && !isImpersonator;

  const navs: INavItem[] = [
    {
      href: '/',
      text: translations.navigation.items.home,
      childHrefs: [],
    },
    {
      href: `/${lang}/study-overview`,
      text: translations.navigation.items.overview,
      childHrefs: [`/${lang}/diagramme`],
    },
    {
      href: `/${lang}/map`,
      text: translations.navigation.items.map,
      childHrefs: [],
    },
  ];

  let navItems = navs;

  if (isApplicant) {
    navItems = [];
  }

  if (!authenticated) {
    navItems = [];
  }

  if (canImpersonateButHaveNotActivatedItYet) {
    navItems = [];
  }

  if (noAccess) {
    navItems = [];
  }

  if (isImpersonator && isImpersonating() && !canViewedUserBeImpersonated) {
    navItems = [];
  }

  return (
    <TranslationsContext.Provider value={translations}>
      {createPortal(
        <MenuComponent navItems={navItems} />,
        document.querySelector('header nav .nav__site')!,
      )}
      {createPortal(
        <UtilityComponent />,
        document.querySelector('header nav .nav__utilities')!,
      )}
    </TranslationsContext.Provider>
  );
};

MenuWrapperComponent.displayName = 'MenuWrapperComponent';
export default MenuWrapperComponent;
